import { getAPIHeaders } from '@/services/api.service';

export async function getLastAmendmentsExport(projectId) {
    const response = await fetch(`/api/projects/${projectId}/amendmentsExports`, {
        headers: getAPIHeaders(),
    });
    return (await response.json()).pop();
}
export async function getAmendmentsExport(projectId, AmendmentsExportId) {
    const response = await fetch(`/api/projects/${projectId}/amendmentsExports/${AmendmentsExportId}`, {
        headers: getAPIHeaders(),
    });
    return await response.json();
}

export async function createAmendmentsExports(projectId, AmendmentsExports) {
    const response = await fetch(
        new Request(`/api/projects/${projectId}/amendmentsExports`, {
            method: 'POST',
            headers: getAPIHeaders({ 'content-type': `application/json` }),
            body: JSON.stringify(AmendmentsExports),
        }),
    );
    if (response && response.ok) {
        return response.json();
    } else {
        throw new Error('Amendment Exports failed');
    }
}
